import { Component, inject, input } from '@angular/core';
import { AufgabenTyp } from '@schir-int-client/aufgabe-shared';
import { CreateAufgabeFormService } from '@schir-int-client/aufgabe';
import { MatFormField, MatInput, MatLabel } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
	selector: 'schir-int-client-notiz-in-aufgabe-editor',
	templateUrl: './notiz-in-aufgabe-editor.component.html',
	styleUrls: ['./notiz-in-aufgabe-editor.component.scss'],
	imports: [MatFormField, MatLabel, ReactiveFormsModule, MatInput],
})
export class NotizInAufgabeEditorComponent {
	private readonly formService = inject(CreateAufgabeFormService);

	readonly aufgabenTyp = input.required<AufgabenTyp>();

	get formGroup() {
		return this.formService.form.controls[this.aufgabenTyp()];
	}
}
